const doc = [({"en":({"js":({"admin":({"agenda_items":({"create_card":({"create_agenda_item":"Create agenda item"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;